import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import config from "@/lib/config";

var AreaCheckAPI = /*#__PURE__*/function () {
  function AreaCheckAPI() {
    var uid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "guest_web";

    _classCallCheck(this, AreaCheckAPI);

    _defineProperty(this, "url", config.areaCheck.url);

    _defineProperty(this, "apiKey", config.areaCheck.key);

    this.uid = uid;
  }

  _createClass(AreaCheckAPI, [{
    key: "check",
    value: function () {
      var _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lat, lng) {
        var params, qs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // debug 広島の緯度経度
                // lat = 34.40458483926412;
                // lng = 132.45550318583173;
                params = {
                  api_key: this.apiKey,
                  uid: this.uid,
                  lat: lat,
                  lng: lng
                };
                qs = new URLSearchParams(params);
                _context2.next = 4;
                return fetch("".concat(this.url, "?").concat(qs)).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = res.ok;
                            _context.next = 3;
                            return res.json();

                          case 3:
                            _context.t1 = _context.sent;
                            return _context.abrupt("return", {
                              ok: _context.t0,
                              json: _context.t1
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function check(_x, _x2) {
        return _check.apply(this, arguments);
      }

      return check;
    }()
  }]);

  return AreaCheckAPI;
}();

export default AreaCheckAPI;